
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dados",
      function () {
        return require("private-next-pages/dados.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dados"])
      });
    }
  